export function getStateIndex(ticket, state) {
  return ticket.states.findIndex(({ main_state }) => main_state === state)
}
